import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import CustomFormInputs from 'MeetingsLib/components/input/CustomFormInputs';
// @ts-expect-error untyped import
import { getIsUngatedForBlockFreeDomains } from 'MeetingsLib/selectors/BookInfoSelectors';
import { useAppSelector } from 'MeetingsLib/redux/reducers';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import FullNameInput from 'ui-addon-i18n/components/FullNameInput';
import BookingFormField from './BookingFormField';
import EmailFormFieldAsync from './EmailFormFieldAsync';
import { Form } from 'foundations-components/transitional/components/Form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BookingFormFields = ({
  disabled,
  formFields,
  formStateValidation,
  formState,
  setFormValue
}) => {
  const isUngatedForBlockFreeDomains = useAppSelector(getIsUngatedForBlockFreeDomains);
  const renderField = (fieldName, validation) => {
    return /*#__PURE__*/_jsx(BookingFormField, {
      fieldName: fieldName,
      validation: formStateValidation.get(fieldName) || validation,
      fieldValue: disabled ? '' : formState.get(fieldName),
      isRequired: true,
      fieldLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `prebook.details.field.${fieldName}`
      }),
      setFormValue: setFormValue,
      autocomplete: "on",
      disabled: disabled
    });
  };
  const renderEmailFormFieldAsync = () => {
    return /*#__PURE__*/_jsx(EmailFormFieldAsync, {
      validation: formStateValidation.get('email'),
      fieldValue: disabled ? '' : formState.get('email'),
      isRequired: true,
      fieldLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'prebook.details.field.email'
      }),
      setFormValue: setFormValue,
      autocomplete: "on",
      disabled: disabled
    });
  };
  const renderEmailField = () => {
    return isUngatedForBlockFreeDomains ? renderEmailFormFieldAsync() : renderField('email');
  };
  const renderCustomFormFields = () => {
    return /*#__PURE__*/_jsx(CustomFormInputs, {
      formFields: formFields,
      formStateValidation: formStateValidation.get('customFormFields'),
      customFormFields: formState.get('customFormFields'),
      onCustomFormFieldChange: setFormValue,
      disabled: disabled
    });
  };
  const renderNameFields = () => {
    return /*#__PURE__*/_jsx(FullNameInput, {
      direction: "row",
      wrap: "wrap",
      givenNameInput: renderField('firstName'),
      familyNameInput: renderField('lastName'),
      firstInputProps: {
        disabled
      },
      secondInputProps: {
        disabled
      }
    });
  };
  return /*#__PURE__*/_jsxs(Form, {
    paddingBlockEnd: "400",
    paddingInline: "800",
    children: [renderNameFields(), renderEmailField(), renderCustomFormFields()]
  });
};
export default BookingFormFields;